import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, testid }) => (
  <Reveal className="max-w-3xl mb-12 lg:mb-16">
    <p className="font-mono text-xs uppercase tracking-[0.3em] text-sky-300 mb-4">{eyebrow}</p>
    <h2 data-testid={testid} className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.05] tracking-tight">
      {title}
    </h2>
  </Reveal>
);
